// Sentry initialization should be imported first!
import './instrument'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initRum } from './utils/cloudwatchRum'
import './index.scss'

// Initialize CloudWatch RUM
initRum()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
